import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
// @mui
import { Box, Link, Typography } from '@mui/material';
import './logo.css';

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, sx, ...other }, ref) => {
  const { adaptorType } = window;
  const adaptorVersion = useSelector((state) => state.app.adaptorVersion);

  const logo = (
    <Box
      ref={ref}
      component="div"
      sx={{
        width: 150,
        height: 30,
        display: 'inline-flex',
        ...sx,
      }}
      {...other}
    >
      <Typography variant="h5" className="glow" sx={{ color: 'text.secondary' }}>
        {adaptorType ? adaptorType.toUpperCase() : ''} <sup>{adaptorVersion}</sup>
      </Typography>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return (
    <Link to="/" component={RouterLink} sx={{ display: 'contents' }}>
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  sx: PropTypes.object,
  disabledLink: PropTypes.bool,
};

export default Logo;
